// src/components/PatientCard.tsx
import React, { memo } from "react";
import { Patient } from "../types";

interface PatientCardProps {
  patientData: Patient | null;
}

const PatientCard: React.FC<PatientCardProps> = memo(({ patientData }) => {
  if (!patientData) return null;

  return (
    <div className="patient-card" style={{
      background: `linear-gradient(135deg, ${{
        "ICU": "#e74c3c",
        "ER": "#f39c12",
        "PACU": "#9b59b6",
        "Med-Surg": "#3498db",
        "NICU": "#e91e63",
        "Labor & Delivery": "#2ecc71",
        "Psychiatry": "#9b59b6",
        "Rehab": "#3498db",
        "Pediatrics": "#e91e63",
      }[patientData.Department || ""] || "#667eea"} 0%, #667eea99 100%)` }}>
      <div className="card-header">
        <h2>👤 {patientData.Name}</h2>
        <div className="department-badge">{patientData.Department || "General"}</div>
      </div>
      <div className="card-fields">
        <span><b>ID MRN:</b> {patientData.MRN}</span>
        <span><b>DOB:</b> {patientData.DOB}</span>
        <span><b>Room:</b> {patientData.Room}</span>
        <span><b>Attending:</b> {patientData.Attending}</span>
      </div>
      <div>
        <b>Diagnosis:</b> {patientData.Diagnosis}
      </div>
      <div>
        <b>Admitted:</b> {patientData.Admission_Date}
      </div>
    </div>
  );
});

PatientCard.displayName = 'PatientCard';

export default PatientCard;